import { z } from 'zod'

export const MEDICARE_AMOUNT_SIGNS = ['POSITIVE', 'NEGATIVE', 'NONE'] as const

const MedicareAmountSignSchema = z.enum(MEDICARE_AMOUNT_SIGNS, {
  errorMap: () => ({ message: 'Select Positive, Negative, or N/A' }),
})

export type MedicareAmountSign = z.infer<typeof MedicareAmountSignSchema>

export const isMedicareAmountSign = (
  value: unknown
): value is MedicareAmountSign =>
  MedicareAmountSignSchema.safeParse(value).success

// Both columns are required on save, and never N/A in both.
export const MedicareColumnsSchema = z
  .object({
    medicareEmployeeSign: MedicareAmountSignSchema,
    medicareEmployerSign: MedicareAmountSignSchema,
  })
  .refine(
    ({ medicareEmployeeSign, medicareEmployerSign }) =>
      !(medicareEmployeeSign === 'NONE' && medicareEmployerSign === 'NONE'),
    {
      path: ['medicareEmployerSign'],
      message: 'At least one Medicare column must be Positive or Negative',
    }
  )

export type MedicareColumnsFormValues = z.infer<typeof MedicareColumnsSchema>
